import { Paper, styled } from "@mui/material";

export const PaperBox = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
}));